import { sendGoogleEvent } from '@html/_common/utils';

import AOCarousel from '@atomic/organisms/_common/carousel/carousel';

export default function initiateAnimalsYouWillSee(eventCategory) {
  const animalsCarousel = new AOCarousel('.js-ao-tour-animals-you-will-see__carousel');
  const eventAction = 'Animals';

  $('body').on('click', '.js-ao-tour-animals-you-will-see__image', () => {
    sendGoogleEvent(
      eventCategory,
      eventAction,
      'Click Thumbnail',
    );
  });

  animalsCarousel.onScrollAnalytics(() => {
    sendGoogleEvent(
      eventCategory,
      eventAction,
      'Scroll',
    );
  });
  animalsCarousel.onLeftClickAnalytics(() => {
    sendGoogleEvent(
      eventCategory,
      eventAction,
      'Previous',
    );
  });
  animalsCarousel.onRightClickAnalytics(() => {
    sendGoogleEvent(
      eventCategory,
      eventAction,
      'Next',
    );
  });
  animalsCarousel.initiate();
}
